import { MenuInterface } from 'src/app/_core/components/layout-nav/routes';

export const activitySuppliersInvoicesRoutes: MenuInterface[] = [
    {
        code: 'SupplierInvoicesList',
        route: [
            {
                content: '$type/suppliers/invoices/list',
                focus: 'empty',
            }, 'content'
        ],
    }
];
